import { Roles } from 'utils/constants';
import { CTA, Section } from './roles-constant';

export const permissions = {
  [CTA.addPaymentMethod]: [Roles.AddPaymentMethod],
  [CTA.editPaymentMethod]: [Roles.DeletePaymentMethod, Roles.EditPaymentMethods, Roles.AddPaymentMethod],
  [CTA.deletePaymentMethod]: [Roles.DeletePaymentMethod],
  [CTA.buyNow]: [Roles.ProcessQuote, Roles.CompleteCheckout, Roles.PayInvoice],

  [Section.modifyPaymentMethod]: [Roles.DeletePaymentMethod, Roles.EditPaymentMethods, Roles.AddPaymentMethod],
};
